import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { ConfigurationDetailsComponent } from '../pages/configuration-details/configuration-details.component';

@EnableClassTelemetry()
@Injectable()
export class CanDeactivateQueryTopicsService {
  canDeactivate(component: ConfigurationDetailsComponent): Promise<boolean> {
    return new Promise(async (resolve) => {
      if (component.configTabs && component.configTabs.length) {
        const promises = [];
        component.configTabs.forEach((c) =>
          promises.push(new Promise((r) => c.checkQueryTopicEdit(r)))
        );
        const res = await Promise.all(promises);
        return resolve(res.every((r) => r));
      } else {
        resolve(true);
      }
    });
  }
}
